const userData = localStorage.userData ? JSON.parse(localStorage.userData) : null
const hasUserAgency = userData ? (userData.user_permissions || []).some(p => p.codename === 'user_agency') : false

const talentosItem = {
  title: 'talentos',
  img_svg: 'proposals_black',
  route: 'talentos',
  resource: 'Creator',
  action: 'manage',
  newLabel: false,
  disabled: false,
}

const proposalsItem = {
  title: 'proposals',
  img_svg: 'proposals_black',
  route: 'view_proposals_edit',
  resource: 'Creator',
  action: 'manage',
  newLabel: false,
  disabled: false,
}

export default [
  {
    header: 'Dashboards',
    img_svg: 'dashboard_black',
    title: 'home',
    route: 'dashboard-analytics',
    resource: 'Dashboard',
    action: 'manage',
    newLabel: false,
    exclude: ['realty']
  },
  {
    title: 'castingCalls',
    img_svg: 'megafono_black',
    route: 'marcas',
    resource: 'Creator',
    action: 'manage',
    newLabel: false,
    avaible_with_no_session: true
  },
  hasUserAgency ? talentosItem : proposalsItem,
]
